import {User} from "../../../models/User";
import {CURRENT_USER_STORAGE_KEY} from "./LocalStorageKeys";

/**
 * Service managing the authentication in local storage.
 * @author Alizée Grand
 * @version 1.2
 * @creation 13/08/2021
 * @last_update 11/01/2022
 **/
class AuthenticationLocalService {

    /**
     * Returns a request header containing the token of the connected user.
     * @returns {any} Formatted JSON with token. The object is empty if there is not connected user.
     */
    authHeader(): any {
        let obj: any = {};
        const currentUser = this.getCurrentUser();
        if(currentUser && currentUser.token) {
            obj = {
                'Content-Type' : 'application/json',
                "Authorization": "Bearer " + currentUser.token
            };
        }
        return obj;
    }

    /**
     * Retrieves the logged-in user's information and stores it in the local storage.
     * @param token {string} User's token returned by the API to prove the authenticity of the connection.
     * @param id {string} Identifier provided by the user at the time of his connection.
     */
    login(token: string, id: string): void {
        const newUser = new User(id, token);
        const stringify = JSON.stringify(newUser);
        localStorage.setItem(CURRENT_USER_STORAGE_KEY, stringify);
    }

    /**
     * Allows you to disconnect.
     * Removes the logged-in user from local storage.
     * Refreshes the page.
     */
    logout() {
        localStorage.removeItem(CURRENT_USER_STORAGE_KEY);
        window.location.assign("/");
    }

    /**
     * Retrieves the logged-in user.
     * Returns the default user if no one is.
     */
    getCurrentUser(): User | null {
        let currentUser = "";
        const item = localStorage.getItem(CURRENT_USER_STORAGE_KEY);
        if(item) {
            currentUser = JSON.parse(item);
        }
        return User.remapUser(currentUser);
    }

    /**
     * Checks if one user is connected.
     * @returns {boolean} True if one user is connected, false otherwise.
     */
    isUserConnected() {
        return this.getCurrentUser() !== null;
    }
}

export default new AuthenticationLocalService();
